module.exports = __webpack_public_path__ + "static/img/product_banner02.0cea5b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/product_banner02.png
// module id = 1An4
// module chunks = 0